// react
import { useState, useEffect } from "react";

// view
import BaseModal from "./BaseModal";
import { Menu, Form, Button, Input, message } from "antd";
import { UserOutlined } from "@ant-design/icons";
import TagGroup from "~/components/tag/TagGroup";

// redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { fetchTagGroups } from "~/redux/actions/app";
import { updateUserInfo } from "~/redux/actions/user";
import { getLevels } from "~/redux/actions/app";

// views
import GenderRadio from "~/components/users/GenderRadio";

// utils
import _ from "lodash";
import { onInputChange } from "~/utils/form";

const Modal = (props) => {
  // props
  const { user } = props;
  const fieldGroup = () => _.find(props.tagGroups, { code: "field" });
  const skillTypeGroup = () => _.find(props.tagGroups, { code: "skill_type" });
  const levelTagNumber = _.find(props.levels, { level: user.level_info.level });

  // hooks
  const [state, setState] = useState({
    nickname: user.nickname,
    gender: user.gender,
    field_tags: null,
    skill_type_tags: null,
    wechat_id: user.wechat_id,
    contact_email: user.contact_email,
    ready: false,
  });

  // handles
  const handleInit = () => {
    props.getLevels();
    props.fetchTagGroups();
  };
  const handleUserDetailed = () => {
    if (user.detailed) {
      props.hideModal();
    }
  };
  const handleTagGroups = () => {
    if (props.tagGroups) {
      const userTagIds = _.map(user.tags, "id");
      const fieldTags = _.map(fieldGroup().tags, "id");
      const skillTypeTags = _.map(skillTypeGroup().tags, "id");

      setState({
        ...state,
        field_tags: _.intersection(fieldTags, userTagIds),
        skill_type_tags: _.intersection(skillTypeTags, userTagIds),
        ready: true,
      });
    }
  };
  const handleInputChange = onInputChange({ state, setState });
  const handleSubmit = () => {
    const wechatId = _.trim(state.wechat_id);
    if (!wechatId) {
      message.error("请填写微信号");
      return;
    }
    props.updateUserInfo(props.token, {
      nickname: state.nickname,
      gender: state.gender,
      wechat_id: wechatId,
      contact_email: _.trim(state.contact_email),
      tag_ids: _.chain([])
        .concat(state.field_tags, state.skill_type_tags)
        .compact()
        .value(),
    });
  };

  // events
  useEffect(() => handleUserDetailed(), [props.user]);
  useEffect(() => handleTagGroups(), [props.tagGroups]);
  useEffect(() => handleInit(), []);

  return (
    <BaseModal
      isOpen={props.isOpen}
      hideModal={props.hideModal}
      className="modal-profile-edit"
      noClose
      showLogo
    >
      <Menu
        mode="horizontal"
        selectedKeys={["edit"]}
      >
        <Menu.Item key="edit">完善信息</Menu.Item>
      </Menu>

      <Form onFinish={handleSubmit}>
        <Form.Item>
          <Input
            name="nickname"
            placeholder="您的称呼"
            prefix={<UserOutlined />}
            value={state.nickname}
            onChange={handleInputChange}
          />
        </Form.Item>

        <Form.Item>
          <GenderRadio
            defaultValue={state.gender}
            name="gender"
            onChange={handleInputChange}
          />
        </Form.Item>

        <Form.Item label="微信" required>
          <Input
            name="wechat_id"
            value={state.wechat_id}
            onChange={handleInputChange}
          />
        </Form.Item>
        <Form.Item label="邮箱">
          <Input
            name="contact_email"
            value={state.contact_email}
            onChange={handleInputChange}
          />
          <div className="text-sm text-secondary line-height-40">
            微信号必填，邮箱选填。只显示给对你感兴趣的人或工作机会，请放心填写。
          </div>
        </Form.Item>

        {state.ready && props.levels && (
          <div>
            <Form.Item label="专业领域">
              <TagGroup
                name="field_tags"
                tagGroup={fieldGroup()}
                selected={state.field_tags}
                limit={levelTagNumber.job_tag_number}
                onChange={handleInputChange}
              />
            </Form.Item>

            <Form.Item label="职业身份">
              <TagGroup
                name="skill_type_tags"
                tagGroup={skillTypeGroup()}
                selected={state.skill_type_tags}
                limit={levelTagNumber.identity_tag_number}
                onChange={handleInputChange}
              />
            </Form.Item>
          </div>
        )}

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            disabled={!props.tagGroups}
            block
          >
            提交
          </Button>
        </Form.Item>
      </Form>
    </BaseModal>
  );
};

const mapStateToProps = (state) => ({
  user: state.user.user,
  token: state.user.token,
  tagGroups: state.app.tagGroups,
  levels: state.app.levels,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchTagGroups,
      updateUserInfo,
      getLevels,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Modal);
